<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="选择发票" :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="proofbill" :store="store" selectType="radio" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				index: 0,
				type:'unserlineorder',
				foreingKey: {},
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'code',
						title: '单据编码',	
						
					},{
						field: 'invoiceType',
						title: '发票类型'
					},{
						field: 'tradecode',
						title: '系统单号',
						render:'$input'
					},{
						field: 'invoicenumber',
						title: '发票号码',	
						
					},{
						field: 'invoiceamount',
						title: '发票金额',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: true,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		methods: {
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				// console.log(resolve, reject)
				return new Promise((resolve, reject) => {
					this.$api.universalinvoiceapply.getUniversalinvoice({
						type:this.type,
						mode: 'box',
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>